module.exports = __webpack_public_path__ + "img/horizontal_3_1_pp1_6005.dd81b484.png";